<div class="flex w-[462px] flex-col gap-3 p-12">
  <div>
    <h3 class="mb-2 font-medium text-surface-900" i18n>
      Edit Personal Information
    </h3>
    <p class="font-medium text-surface-500" i18n>
      Make sure your information is correct.
    </p>
  </div>

  <form class="flex flex-col gap-3" [formGroup]="form">
    <p-floatlabel variant="in">
      <p-iconfield>
        <p-inputicon>
          <ng-icon
            name="phosphorUser"
            class="icon-primary text-xl text-primary"></ng-icon>
        </p-inputicon>
        <input
          pInputText
          name="firstName"
          type="text"
          fluid
          formControlName="firstName"
          id="firstName" />
      </p-iconfield>
      <label for="firstName" i18n>Name</label>
    </p-floatlabel>

    <p-floatlabel variant="in">
      <p-iconfield>
        <p-inputicon>
          <ng-icon
            name="phosphorUser"
            class="icon-primary text-xl text-primary"></ng-icon>
        </p-inputicon>
        <input
          pInputText
          name="lastName"
          type="text"
          fluid
          formControlName="lastName"
          id="lastName" />
      </p-iconfield>
      <label for="lastName" i18n>Last name</label>
    </p-floatlabel>

    <p-floatlabel variant="in">
      <p-datepicker
        iconDisplay="input"
        [showIcon]="true"
        [minDate]="minBirthdate"
        [maxDate]="maxBirthdate"
        formControlName="birthdate"
        name="birthdate"
        fluid
        id="birthdate">
        <ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
          <ng-icon
            name="phosphorCalendarBlank"
            class="icon-primary cursor-pointer text-xl text-primary"
            (click)="clickCallBack($event)"></ng-icon>
        </ng-template>
      </p-datepicker>
      <label for="birthdate" i18n>Birthdate</label>
    </p-floatlabel>
  </form>

  <error-small-component></error-small-component>

  <div class="mt-4 flex gap-2">
    <button
      pButton
      pRipple
      [outlined]="true"
      class="w-full !text-sm"
      (click)="clickCancel()"
      i18n>
      Cancel
    </button>
    <button pButton pRipple class="w-full !text-sm" (click)="submit()" i18n>
      Save
    </button>
  </div>
</div>
